import type { ComponentType, ReactNode } from "react";
import type { ButtonTone } from "./Button";

/**
 * The confirmation step a control puts in front of its action — shared by
 * `Button`'s and `Checkbox`'s `confirm` prop, so a confirm reads the same
 * wherever it appears.
 *
 * A bare string is shorthand for using it as both title and message.
 */
export interface ConfirmConfig {
  title: string;
  message: ReactNode;
  confirmLabel?: string | undefined;
  /** The button that backs out; "Cancel" when omitted. */
  cancelLabel?: string | undefined;
  icon?: ComponentType<{ className?: string }> | undefined;
  iconTone?: ButtonTone | undefined;
  /** When set, the dialog collects free text and passes it to the action. */
  inputLabel?: string | undefined;
  inputPlaceholder?: string | undefined;
  inputDefaultValue?: string | undefined;
}

/** Normalise the `confirm` prop's string shorthand into a full config. */
export function resolveConfirmConfig(
  confirm: string | ConfirmConfig | undefined,
): ConfirmConfig | undefined {
  if (confirm === undefined) {
    return undefined;
  }
  return typeof confirm === "string"
    ? { title: confirm, message: confirm }
    : confirm;
}
